import { render, staticRenderFns } from "./appointmentCard.vue?vue&type=template&id=5adff277&scoped=true&"
import script from "./appointmentCard.vue?vue&type=script&lang=js&"
export * from "./appointmentCard.vue?vue&type=script&lang=js&"
import style0 from "./appointmentCard.vue?vue&type=style&index=0&id=5adff277&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adff277",
  null
  
)

export default component.exports